import React from 'react';
import { Modal } from '@gerdau/hefesto/';

interface Props {
  loading: boolean;
  showChangeBPModal: boolean;
  handleChangeBPButton: () => void;
  handleCancelButton: () => void;
}

export const ChangeBPModal = ({
  loading,
  showChangeBPModal,
  handleChangeBPButton,
  handleCancelButton
}: Props) => {
  if (!showChangeBPModal) {
    return null;
  }

  return (
    <Modal
      title="Alteração do emissor"
      children={
        <p>Seu pedido em andamento será perdido. Deseja alterar o emissor?</p>
      }
      buttons={{
        left: {
          name: 'Manter o emissor',
          children: 'Manter emissor',
          onClick: () => handleCancelButton(),
          loading
        },
        right: {
          name: 'Alterar o emissor',
          children: 'Alterar emissor',
          onClick: () => handleChangeBPButton(),
          disabled: loading
        }
      }}
      modalSize="sm"
    ></Modal>
  );
};
